import React from "react";

const VisibleContent = ({ visible, children }) => {
	if (!visible) return null;
	return children
}

export default VisibleContent
